// this file contains all of the valid note names for all pitches between C-4 and C11
export {};
//# sourceMappingURL=NoteUnits.js.map